import { useCallback, useRef, useState } from 'react';

export default function useTimer() {
  const timeRef = useRef<NodeJS.Timeout | number>();
  const idleTimeRef = useRef<NodeJS.Timeout | number>();

  const [time, setTime] = useState(0);
  const [idleTime, setIdleTime] = useState(0);

  // main timer
  const startMainTimer = useCallback(() => {
    setTime(0);

    timeRef.current = setInterval(() => {
      setTime((old) => old + 1);
    }, 1000);
  }, []);

  const resetMainTimer = useCallback(() => {
    clearInterval(timeRef.current as number);
    startMainTimer();
  }, [startMainTimer]);

  const endMainTimer = useCallback(() => {
    clearInterval(timeRef.current as number);
    setTime(0);
  }, []);

  // idle timer
  const startIdleTimer = useCallback(() => {
    setIdleTime(0);

    idleTimeRef.current = setInterval(() => {
      setIdleTime((old) => old + 1);
    }, 1000);
  }, []);

  const resetIdleTimer = useCallback(() => {
    clearInterval(idleTimeRef.current as number);
    startIdleTimer();
  }, [startIdleTimer]);

  const endIdleTimer = useCallback(() => {
    clearInterval(idleTimeRef.current as number);
    setIdleTime(0);
  }, []);

  // timer
  const startTimer = useCallback(() => {
    startMainTimer();
    startIdleTimer();
  }, [startIdleTimer, startMainTimer]);

  const resetTimer = useCallback(() => {
    resetMainTimer();
    resetIdleTimer();
  }, [resetIdleTimer, resetMainTimer]);

  const endTimer = useCallback(() => {
    endMainTimer();
    endIdleTimer();
  }, [endIdleTimer, endMainTimer]);

  return {
    time,
    idleTime,
    startMainTimer,
    resetMainTimer,
    endMainTimer,
    startIdleTimer,
    resetIdleTimer,
    endIdleTimer,
    startTimer,
    resetTimer,
    endTimer,
  };
}
